var _path, _path2, _path3, _path4, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFeteIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    fill: "none",
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeOpacity: 0.08,
    strokeWidth: 0.75,
    d: "M.375 24C.375 10.952 10.952.375 24 .375S47.625 10.952 47.625 24 37.048 47.625 24 47.625.375 37.048.375 24Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "url(#a)",
    strokeWidth: 1.5,
    d: "M24 14.656A14.787 14.787 0 0 0 33.344 24 14.787 14.787 0 0 0 24 33.344 14.787 14.787 0 0 0 14.656 24 14.787 14.787 0 0 0 24 14.656Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#b)",
    d: "M32.867 28.2a4.667 4.667 0 0 1-4.667 4.667 4.667 4.667 0 0 1 4.667 4.666 4.667 4.667 0 0 1 4.666-4.666 4.667 4.667 0 0 1-4.666-4.667Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#c)",
    d: "M14.667 10A4.667 4.667 0 0 1 10 14.667a4.667 4.667 0 0 1 4.667 4.666 4.667 4.667 0 0 1 4.666-4.666A4.667 4.667 0 0 1 14.667 10Z"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: 38,
    x2: 4.495,
    y1: 10,
    y2: 20.601,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EC52FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1E0AF5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    x1: 37.533,
    x2: 26.365,
    y1: 28.2,
    y2: 31.734,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EC52FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1E0AF5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "c",
    x1: 19.333,
    x2: 8.165,
    y1: 10,
    y2: 13.534,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EC52FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1E0AF5"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeteIcon);
export default __webpack_public_path__ + "static/media/feteIcon.ae499bdc2cd8aef3002aa0ad7d2de761.svg";
export { ForwardRef as ReactComponent };